import React, { useCallback, useEffect, useState } from 'react';
import Dashboard from 'domain/entity/dashboard';
import { useDashboard } from 'adapter/in/dashboards/context/Dashboard';
import { isSome } from 'fp-ts/lib/Option';
import { UpdateDashboardPinCriteriaBuilder } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardPinCritera';
import PinDashboardModal from 'adapter/in/dashboards/pages/Modals/PinModal';

export const useOnPinDashboardModal = (hasPinnedDashboard: boolean, onPinModalSuccess: (pinned: boolean) => void) => {
    const [showPinModal, setShowPinModal] = useState(false);
    const [activeModalDashboard, setActiveModalDashboard] = useState<Dashboard>();
    const { updatePinError, updatePinResult, updatePinIsLoading, updatePin, updatePinReset } = useDashboard();

    useEffect(() => {
        if (isSome(updatePinResult) && activeModalDashboard) {
            handleOnClose();
            onPinModalSuccess(activeModalDashboard?.pinned);
            updatePinReset();
        }
    }, [updatePinResult, activeModalDashboard]);

    const handleUpdate = useCallback(() => {
        if (activeModalDashboard) {
            updatePin(
                UpdateDashboardPinCriteriaBuilder.create().withId(activeModalDashboard.id).withPin(!activeModalDashboard.pinned).build()
            );
        }
    }, [activeModalDashboard]);

    const handleOnPin = (dashboard: Dashboard) => {
        setActiveModalDashboard(dashboard);
        setShowPinModal(true);
    };

    const handleOnClose = () => {
        setShowPinModal(false);
    };

    const onPinModal = (
        <PinDashboardModal
            isUnpinning={activeModalDashboard?.pinned}
            showModal={showPinModal}
            isReplacing={hasPinnedDashboard}
            onClose={handleOnClose}
            onPin={handleUpdate}
            isLoading={updatePinIsLoading}
            error={isSome(updatePinError)}
        />
    );

    return { handleOnPin, onPinModal };
};
